export function getReservationCodeType() {
    let type = 'barcode';
    let item = localStorage.getItem('xs_reservation_print_type');
	if (item != null) {
        type = item;
    }
    return type;
}
